// src/components/CouponRevealDialog.js
import React, { useState } from 'react';

const CouponRevealDialog = ({ couponCode, onClose }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(couponCode).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    });
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: '400px', padding: '30px' }} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-btn" style={{ top: '15px', right: '15px' }}>&times;</button>
        <div style={{ textAlign: 'center' }}>
          {/* Icon */}
          <div style={{ fontSize: '3em', color: 'var(--green-accent)', marginBottom: '15px' }}>
            <i className="fas fa-gift"></i>
          </div>

          {/* Text Content */}
          <h3 style={{ margin: '0 0 10px 0' }}>Thank You for Subscribing!</h3>
          <p style={{ color: 'var(--text-color-secondary)', lineHeight: '1.5' }}>Here is your exclusive welcome coupon:</p>

          {/* Coupon Code and Button */}
          <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              margin: '25px 0', 
              gap: '15px', 
              padding: '10px', 
              backgroundColor: 'var(--bg-color)', 
              borderRadius: 'var(--border-radius-md)' 
          }}>
            <strong style={{ 
                border: '2px dashed var(--primary-orange)', 
                padding: '10px 20px', 
                fontSize: '1.2em', 
                borderRadius: 'var(--border-radius-sm)',
                color: 'var(--primary-orange)',
                flexGrow: 1
            }}>
              {couponCode}
            </strong>
            <button 
              onClick={handleCopy} 
              className="admin-btn"
              style={{ 
                  backgroundColor: isCopied ? 'var(--green-accent)' : 'var(--primary-orange)', 
                  color: 'white', 
                  margin: 0,
                  padding: '12px',
                  borderRadius: 'var(--border-radius-md)',
                  width: '100px'
              }}
            >
              {isCopied ? 'Copied!' : 'Copy'}
            </button>
          </div>
          
          <p style={{fontSize: '0.9em', color: 'var(--text-color-secondary)'}}>You can use this code in the cart on your next order.</p>
        </div>
      </div>
    </div>
  );
};

export default CouponRevealDialog;
